{
  "collectionLabel": "Sugestões"
}
